export default __webpack_public_path__ + "static/gesturing-1acf43bc74b421fe60be509a6463b473.svg";